import * as Models from '@/api/T2/userMap';

export default {
  namespaced: true,
  state: {
    checkoutListData: []
  },
  getters: { checkoutListData: state => state.checkoutListData },
  actions: {
    async getPointList(ctx, payload) {
      const data = await Models.getPointList(payload)
      return data && data.status === 200 && data.data || {}
    },

    async getAllCity(ctx, payload) {
      const data = await Models.getAllCity(payload)
      return data && data.status === 200 && data.data || {}
    },
  },
  mutations: {
    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    }
  }
}